import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "w-full h-full flex items-center justify-center py-4 md:py-6 lg:py-12 px-4 sm:px-6 overflow-hidden",
  id: "main-container-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full flex-shrink-0"
}
const _hoisted_3 = { class: "w-full h-full overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["relative h-full w-full flex flex-row items-center justify-center overflow-hidden", `bg-${_ctx.finalMainContainerStyle.backgroundColor}`])
  }, [
    _renderSlot(_ctx.$slots, "prepend"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full h-full rounded-md p-6 flex flex-col", `bg-${_ctx.finalMainContainerStyle.containerBackgroundColor} max-w-${_ctx.finalMainContainerStyle.containerMaxWidth}`]),
        id: "main-container"
      }, [
        (_ctx.$slots.title == null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["flex flex-row justify-between items-center mb-2 flex-shrink-0", `text-${_ctx.finalMainContainerStyle.titleColor}`])
            }, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.title), 1),
              _renderSlot(_ctx.$slots, "actionButton")
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "title")
            ])),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2)
    ]),
    _renderSlot(_ctx.$slots, "append")
  ], 2))
}